package org.hs_soft.runmynesto.pages.components

import androidx.compose.runtime.Composable
import androidx.compose.runtime.LaunchedEffect
import androidx.compose.runtime.mutableStateOf
import androidx.compose.runtime.remember
import androidx.compose.web.events.SyntheticMouseEvent
import com.varabyte.kobweb.compose.css.Cursor
import com.varabyte.kobweb.compose.css.FontWeight
import com.varabyte.kobweb.compose.css.Transition
import com.varabyte.kobweb.compose.css.accentColor
import com.varabyte.kobweb.compose.css.cursor
import com.varabyte.kobweb.compose.css.functions.RadialGradient
import com.varabyte.kobweb.compose.css.height
import com.varabyte.kobweb.compose.css.transition
import com.varabyte.kobweb.compose.foundation.layout.Box
import com.varabyte.kobweb.compose.foundation.layout.Row
import com.varabyte.kobweb.compose.ui.Alignment
import com.varabyte.kobweb.compose.ui.Modifier
import com.varabyte.kobweb.compose.ui.modifiers.backgroundColor
import com.varabyte.kobweb.compose.ui.modifiers.borderRadius
import com.varabyte.kobweb.compose.ui.modifiers.color
import com.varabyte.kobweb.compose.ui.modifiers.cursor
import com.varabyte.kobweb.compose.ui.modifiers.fontFamily
import com.varabyte.kobweb.compose.ui.modifiers.fontSize
import com.varabyte.kobweb.compose.ui.modifiers.fontWeight
import com.varabyte.kobweb.compose.ui.modifiers.height
import com.varabyte.kobweb.compose.ui.modifiers.margin
import com.varabyte.kobweb.compose.ui.modifiers.onClick
import com.varabyte.kobweb.compose.ui.modifiers.onFocusIn
import com.varabyte.kobweb.compose.ui.modifiers.onFocusOut
import com.varabyte.kobweb.compose.ui.modifiers.onMouseLeave
import com.varabyte.kobweb.compose.ui.modifiers.onMouseOver
import com.varabyte.kobweb.compose.ui.modifiers.size
import com.varabyte.kobweb.compose.ui.modifiers.tabIndex
import com.varabyte.kobweb.compose.ui.thenIf
import com.varabyte.kobweb.silk.components.text.SpanText
import org.hs_soft.runmynesto.domain.config.Dimen
import org.hs_soft.runmynesto.domain.config.FontFamily
import org.hs_soft.runmynesto.domain.config.FontSizes
import org.hs_soft.runmynesto.domain.config.Theme
import org.hs_soft.runmynesto.domain.config.overflowText
import org.hs_soft.runmynesto.domain.util.Constants
import org.jetbrains.compose.web.attributes.InputType
import org.jetbrains.compose.web.attributes.disabled
import org.jetbrains.compose.web.attributes.name
import org.jetbrains.compose.web.css.CSSColorValue
import org.jetbrains.compose.web.css.CSSSizeValue
import org.jetbrains.compose.web.css.CSSUnit
import org.jetbrains.compose.web.css.height
import org.jetbrains.compose.web.css.percent
import org.jetbrains.compose.web.css.px
import org.jetbrains.compose.web.css.width
import org.jetbrains.compose.web.dom.Input

@Composable
fun CustomRadioInput(
    modifier: Modifier = Modifier,
    title: String,
    onClick: () -> Unit,
    checked: Boolean,
    height:CSSSizeValue<CSSUnit.px>?=null,
    parentSize:CSSSizeValue<CSSUnit.px> =Dimen.radioButtonParentSize,
    circleSize:CSSSizeValue<CSSUnit.px> =Dimen.normalIconSize.px,
    fontWeight: FontWeight = FontWeight.Normal,
    enabled: Boolean = true,
    accentColor: CSSColorValue = Theme.PrimaryMain.rgb,
) {
    val isChecked = remember { mutableStateOf(checked) }
    val isHovered = remember { mutableStateOf(false) }
    val isFocused = remember { mutableStateOf(false) }

    LaunchedEffect(key1 = checked) {
        isChecked.value = checked
    }

    Row(
        modifier = modifier
            .thenIf(
                height!=null,
                Modifier.height(height?:0.px)
            )
            .onMouseOver { isHovered.value = true }
            .onMouseLeave { isHovered.value = false }
            .onFocusIn { isFocused.value = true }
            .onFocusOut { isFocused.value = false }
            .onClick { event: SyntheticMouseEvent ->
                if (enabled && !isChecked.value) {
                    isChecked.value = true
                    onClick()
                }
            },
        verticalAlignment = Alignment.CenterVertically,
    ) {
        Box(
            modifier = Modifier
                .size(parentSize)
                .tabIndex(0)
                .borderRadius(50.percent)
                .backgroundColor(
                    if (isFocused.value) {
                        if (isChecked.value)
                            Theme.PrimaryStatesFocus.rgb
                        else Theme.ActionFocused.rgb
                    } else {
                        if (isHovered.value) {
                            if (isChecked.value)
                                Theme.PrimaryStatesHover.rgb
                            else Theme.ActionHover.rgb
                        } else Theme.Transparent.rgb
                    }
                ),
            contentAlignment = Alignment.Center
        ) {
            Input(
                type = InputType.Radio,
                attrs = {
                    if (!enabled)
                        disabled()
                    checked(isChecked.value)
                    name("radioGroup")
                    value(title)
                    onFocus { isFocused.value = true }
                    onBlur { isFocused.value = false }
                    style {
                        accentColor(accentColor)
                        width(circleSize)
                        height(circleSize)
                        cursor(Cursor.Pointer)

                        transition(
                            Transition.of(
                                property = "all",
                                duration = Constants.fastTransition
                            )
                        )
                    }
                }
            )
        }

        SpanText(
            text = title,
            modifier = Modifier
                .cursor(Cursor.Pointer)
                .fontSize(FontSizes.mediumFontSize)
                .fontWeight(fontWeight)
                .overflowText()
                .fontFamily(FontFamily.Jakarta)
                .color(Theme.TextPrimary.rgb)
        )
    }
}